
import { computed, defineComponent } from 'vue';

// Lista única e limpa (não precisa repetir por letras)
const listaVariaveis = [
  'ValorTotal', 'ValorUnitario', 'ValorDesconto', 'ValorTotalProduto', 'Quantidade',
  'DataVenda', 'DataEmissao', 'Produto', 'Participacao',
  'Cliente', 'CPF/CNPJ', 'Cidade', 'UF', 'Unidade',
  'NumeroVenda', 'NumeroNota', 'Vendedor', 'FormaPagamento', 'TipoOperacao',
];

export default defineComponent({
  name: 'SelecionarCamposRelatorioVendas',
  props: {
    campos: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:campos', 'change'],
  setup(props, { emit }) {
    // 1. Transforma a lista de strings em objetos { value, label } para o AntD
    const opcoesDisponiveis = listaVariaveis.map((item) => ({
      value: item,
      label: item,
    }));

    // 2. Computed para lidar com a conversão String <-> Array
    // O a-select (multiple) trabalha com Array, mas sua prop 'campos' é String.
    const computedValor = computed({
      get: () => {
        if (!props.campos) return [];
        // Divide a string por vírgula e remove espaços extras
        return props.campos.split(',').map((s) => s.trim()).filter(Boolean);
      },
      set: (valores: string[]) => {
        // Junta o array de volta em uma string separada por vírgulas
        const stringFinal = valores.join(', ');
        emit('update:campos', stringFinal);
        emit('change', stringFinal);
      },
    });

    // 3. Função de filtro para a busca (case insensitive)
    const filtrarOpcoes = (input: string, option: any) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return {
      opcoesDisponiveis,
      computedValor,
      filtrarOpcoes,
    };
  },
});
